
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface ResourceCardProps {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick: (id: string) => void;
}

const ResourceCard = ({ id, title, description, icon, onClick }: ResourceCardProps) => {
  return (
    <div 
      className="bg-slate-900 rounded-lg p-6 hover:bg-slate-800 transition-all duration-300 cursor-pointer flex flex-col h-full"
      onClick={() => onClick(id)}
    >
      <div className="flex flex-col items-center mb-6">
        <div className="bg-slate-800 p-4 rounded-xl mb-4 flex items-center justify-center w-20 h-20 shadow-md border border-white/5">
          {React.cloneElement(icon as React.ReactElement, { className: "h-12 w-12 text-orange-500" })}
        </div>
        <h3 className="text-xl font-semibold text-white text-center mt-4">{title}</h3>
      </div>
      
      <p className="text-gray-300 mb-6 text-center flex-grow">{description}</p>
      
      <Button 
        variant="ghost" 
        className="text-orange-400 hover:text-orange-300 p-0 flex items-center self-center mt-auto"
        onClick={(e) => {
          e.stopPropagation();
          onClick(id);
        }}
      >
        View Resources <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
};

export default ResourceCard;
